import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { addDevice, fetchDevice, setDeviceEdit, updateDevice } from '../../../action/cassa';
import ErrorContainer from '../../utils/ErrorContainer';
import Input from '../../utils/Input';
import Select from 'react-select';
import { fetchFilials } from '../../../action/handbook';
import { isEqual } from 'lodash';
import Loader from '../../utils/Loader';
import request from '../../../action/utils/request';
import { urls } from '../../../constants/app';
import swal from 'sweetalert';
import { fetchCashiersDevice } from '../../../action/user';


const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class EditDevice extends Component {
    state = {
        cashiers: [],
    };

    componentDidMount () {
        const getCashiers = async (point) => {
            if (point) {
                const result = await this.props.fetchCashiersDevice(point);
        
                if (!result || result.error) {
                    return swal({
                        title: "Ошибка",
                        text: "Не удалось найти кассиров для оборудования",
                        icon: "warning",
                        button: "Ок",
                    });
                }
                return this.setState({ cashiers: result })
            } else {
                return null
            }
        }

        if (!this.props.filials || this.props.filials.length === 0) {
            this.props.fetchFilials();
        }
        this.props.fetchDevice(this.props.match.params.id).then(result => {
            if (result && (!result.host || !result.port || !result.hostMark || !result.portMark)) {
                result.host = result.host ? result.host : 'http://127.0.0.1';
                result.port = result.port ? result.port : 16732;
                result.hostMark = result.hostMark ? result.hostMark : 'http://127.0.0.1';
                result.portMark = result.portMark ? result.portMark : 5995;
            }
            this.props.setDeviceEdit(result);
            getCashiers(result.point.id);
        });
    }

    componentWillUnmount() {
        this.props.setDeviceEdit({});
    }
    
    checkPoint = (point) => {
        if (point.id) {
           const result = this.props.filials.find((el) => el.id === point.id);
           return ({
                value: result.id,
                city: result.city.id,
                label: this.renderAdress(result),
           });
        }

        if (point) {
            return ({
                value: point.value,
                city: point.city,
                label: point.label,
           });
        }
        
        return null;
    }

    checkCashier = (user) => {
        if (user && user.id) {
            return {
                label: this.renderLabelKashier(user),
                value: user.id
            };
        }

        if (user) {
            return {
                value: user.value,
                label: user.label,
            }
        }

        return null;
    }

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Изменение оборудования {this.props.edit.id ? 'ID: ' + this.props.edit.id : ''}</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/cassa/devices')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValid() {
        const { name, port, host, ffd, login, password, point} = this.props.edit;
        if (isEqual(this.props.detail, this.props.edit)) return false;
        if (name && port && host && ffd && login && password && point) return true;
        
        return false;
    }

    setDevice = (field) => (e) => {
        const data = {...this.props.edit};

        const getCashiers = async (point) => {
            if (point) {
                const result = await this.props.fetchCashiersDevice(point);
        
                if (!result || result.length <= 0 || result.error) {
                    return swal({
                        title: "Ошибка",
                        text: "Не удалось найти кассиров для оборудования",
                        icon: "warning",
                        button: "Ок",
                    });
                }
                return this.setState({ cashiers: result })
            } else {
                return null
            }
        }

        if (field === 'point') {
            this.setState({ cashiers: [] })
            data.user = null;
            getCashiers(e.value);
        }

        if (field === 'point' || field === 'user') {
            data[field] = e;
        } else if (field === 'ffd') {
            data[field] = e.value;
        } else {
            data[field] = e.target.value;
        }
        this.props.setDeviceEdit(data);
    }

    onSubmit = async (e) => {
        e.preventDefault();

        if (this.props.edit.point && this.props.edit.point.value) {
            const params = {};
            params['point.id'] = this.props.edit.point.value;
            const result = await request({ method: 'get', url: `${urls.devices}`, params });
            const devices = result;

            if (devices && devices.length > 0 && devices[0].id !== this.props.edit.id) {
                return swal({
                    title: "У филиала есть оборудование",
                    text: "Измените или удалите существующее оборудование филиала",
                    icon: "warning",
                    button: "Ок",
                });
            }
        }
        
        this.props.updateDevice(this.props.edit).then(result => {
            if (result) {
                this.props.history.push('/cassa/devices');
            }
        });
    }

    renderAdress(item) {
        return `${item.city.name}, ${item.street}, ${item.house}`;
    }

    renderLabelKashier(item) {
        if (item.name) return `${item.name}, ${item.role ? item.role.description || '' : ''}`
        return `${item.username}, ${item.role ? item.role.description || '' : ''}`
    }

    renderAtol = () => {
        const { edit } = this.props;
        
        return (
            <div className='online-pay_block'>
                <h5> АТОЛ </h5>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="Название ККТ"
                            required={true}
                            onChange={this.setDevice('name')}
                            value={edit.name}
                            placeholder="Название ККТ"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Логин"
                            required={true}
                            onChange={this.setDevice('login')}
                            value={edit.login}
                            placeholder="Логин"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Пароль"
                            required={true}
                            onChange={this.setDevice('password')}
                            value={edit.password}
                            placeholder="Пароль"
                        />
                    </div>                                
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="IP Хост"
                            required={true}
                            onChange={this.setDevice('host')}
                            value={edit.host}
                            placeholder="Хост"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Порт"
                            required={true}
                            onChange={this.setDevice('port')}
                            value={edit.port}
                            placeholder="Порт"
                            type='number'
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="deviceID"
                            onChange={this.setDevice('deviceId')}
                            value={edit.deviceId}
                            placeholder="deviceID"
                            type='number'
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-6">
                        <div className='form-group'>
                            <label>ФФД *</label>
                            <Select
                                closeMenuOnSelect={true}
                                value={edit.ffd ? {value: edit.ffd, label: edit.ffd} : null}
                                onChange={this.setDevice('ffd')}
                                placeholder="ФФД"
                                options={
                                    [
                                        {value: 1.2, label: 1.2},
                                        {value: 1.05, label: 1.05}
                                    ]
                                }
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className='form-group'>
                            <label>Кассир</label>
                            <Select
                                isLoading={this.props.loadingFilials}
                                isDisabled={this.props.loadingFilials || !edit.point}
                                closeMenuOnSelect={true}
                                value={(edit.user && (edit.user.id || edit.user.value)) ? { value: edit.user.id || edit.user.value, label: edit.user.label || this.renderLabelKashier(edit.user) }  : null}
                                onChange={this.setDevice('user')}
                                placeholder="Кассир"
                                options={this.state.cashiers.sort((a, b) => {
                                        const nameA = this.renderLabelKashier(a)
                                        const nameB = this.renderLabelKashier(b)
                                        if (nameA < nameB) return -1;
                                        if (nameA > nameB) return 1;
                                        return 0;
                                        })
                                        .map(el => ({
                                        value: el.id,
                                        label: this.renderLabelKashier(el)
                                        })
                                    )
                                }
                                noOptionsMessage={() => 'Нет пользователей'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderMark = () => {
        const { edit } = this.props;
        
        return (
            <div className='online-pay_block'>
                <h5> Честный знак </h5>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="Логин"
                            required={true}
                            onChange={this.setDevice('loginMark')}
                            value={edit.loginMark}
                            placeholder="Логин"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Пароль"
                            required={true}
                            onChange={this.setDevice('passwordMark')}
                            value={edit.passwordMark}
                            placeholder="Пароль"
                        />
                    </div>                                
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="IP Хост"
                            required={true}
                            onChange={this.setDevice('hostMark')}
                            value={edit.hostMark}
                            placeholder="Хост"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Порт"
                            required={true}
                            onChange={this.setDevice('portMark')}
                            value={edit.portMark}
                            placeholder="Порт"
                            type='number'
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        <Input
                            label="Токен ЧЗ"
                            required={true}
                            onChange={this.setDevice('tokenMark')}
                            value={edit.tokenMark}
                            placeholder="Токен ЧЗ"
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.loading || this.props.loadingFilials || !this.props.edit.id) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">
                        <div className='row'>
                                <div className="col-md-6">
                                    <div className='form-group'>
                                        <label>{"Филиал *"}</label>
                                        <Select
                                            isLoading={this.props.loadingFilials}
                                            isDisabled={this.props.loadingFilials}
                                            closeMenuOnSelect={true}
                                            value={this.checkPoint(this.props.edit.point)}
                                            onChange={this.setDevice('point')}
                                            placeholder="Филиал"
                                            options={this.props.filials.map((el) => ({ value: el.id, city: el.city.id, label: this.renderAdress(el) }))}
                                            noOptionsMessage={() => 'Нет филиалов'}
                                        />
                                    </div>
                                </div>
                            </div>
                            {this.renderAtol()}
                            {this.renderMark()}
                        </div>                        
                        <ErrorContainer field="addDevice" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValid() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loading })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    edit: state.cassa.devices.edit,
    detail: state.cassa.devices.detail,
    loading: state.loaders.device,
    filials: state.handbook.filials,
    loadingFilials: state.loaders.filials,
});

const mapDispatchToProps = {
    setDeviceEdit: (data) => setDeviceEdit(data),
    addDevice: (data) => addDevice(data),
    fetchFilials: (city) => fetchFilials(city, true),
    fetchDevice: (id) => fetchDevice(id),
    updateDevice: (data) => updateDevice(data),
    fetchCashiersDevice: (point) => fetchCashiersDevice(point),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditDevice);